var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountBannerRefer = function SvgIconAccountBannerRefer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.833,
    y: 0.5,
    fill: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    fillRule: "evenodd",
    d: "M28.276 22.684a.626.626 0 0 1 0 .885l-3.75 3.75a.626.626 0 0 1-.885 0l-1.875-1.875a.627.627 0 0 1 .885-.885l1.433 1.433 3.307-3.308a.624.624 0 0 1 .885 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "m28.175 18.14-1.152-1.18.894-.872.778.796 1.112-.014a3.61 3.61 0 0 1 3.655 3.655l-.012 1.113.795.777a3.613 3.613 0 0 1 0 5.168l-.796.777.013 1.113a3.61 3.61 0 0 1-3.655 3.655l-1.112-.013-.778.795a3.61 3.61 0 0 1-5.167 0l-.778-.796-1.112.014a3.61 3.61 0 0 1-3.655-3.655l.012-1.113-.795-.777a3.61 3.61 0 0 1 0-5.168l.796-.777-.013-1.113a3.614 3.614 0 0 1 3.655-3.655l1.112.013.778-.795a3.613 3.613 0 0 1 5.167 0l-.894.872a2.363 2.363 0 0 0-3.38 0l-1.15 1.18-1.65-.02a2.364 2.364 0 0 0-2.388 2.39l.02 1.648-1.18 1.151a2.36 2.36 0 0 0 0 3.38l1.18 1.15-.02 1.65a2.363 2.363 0 0 0 2.39 2.389l1.647-.02 1.151 1.18a2.36 2.36 0 0 0 3.38 0l1.15-1.18 1.65.02a2.36 2.36 0 0 0 2.39-2.39l-.02-1.648 1.18-1.151a2.363 2.363 0 0 0 0-3.38l-1.18-1.15.02-1.65a2.363 2.363 0 0 0-2.39-2.389z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.833,
    y: 0.5,
    stroke: "#EAEAEA",
    rx: 24.5
  })));
};
export default SvgIconAccountBannerRefer;